

import { PlatformModule } from '@angular/cdk/platform';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { IconDefinition } from '@ant-design/icons-angular';

import { MwcIconDirective } from './icon.directive';
import { MwcIconPatchService, NZ_ICONS, NZ_ICONS_PATCH } from './icon.service';

@NgModule({
  exports: [MwcIconDirective],
  declarations: [MwcIconDirective],
  imports: [PlatformModule]
})
export class MwcIconModule {
  static forRoot(icons: IconDefinition[]): ModuleWithProviders<MwcIconModule> {
    return {
      ngModule: MwcIconModule,
      providers: [
        {
          provide: NZ_ICONS,
          useValue: icons
        }
      ]
    };
  }

  static forChild(icons: IconDefinition[]): ModuleWithProviders<MwcIconModule> {
    return {
      ngModule: MwcIconModule,
      providers: [
        MwcIconPatchService,
        {
          provide: NZ_ICONS_PATCH,
          useValue: icons
        }
      ]
    };
  }
}
